(function () {
    'use strict';

    angular.module('app').factory('notificationReplyService', NotificationReplyServiceFactory);

    NotificationReplyServiceFactory.$inject = ['rx',];
    function NotificationReplyServiceFactory(rx) {
        const subject = new rx.Subject();
        let data = {};

        const service = {
            set: function set(d) {
                data = d;
                data.Message = ''; // Reset the editor text
                subject.onNext(d);
            },
            get: function get() {
                return data;
            },
            subscribe: function (o) {
                return subject.subscribe(o);
            }
        };
        return service;
    }
})();
